import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  BarChart3,
  TrendingUp,
  Landmark,
  Newspaper,
  Gamepad2,
  Trophy,
  Flame,
  Stethoscope,
  X
} from 'lucide-react';
import logoGuiaDoPovo from '../../assets/logo_guia_do_povo.png';

const menuItems = [
  { path: '/', label: 'Visão Geral', icon: LayoutDashboard },
  { path: '/dados', label: 'Dados', icon: BarChart3 },
  { path: '/stocks', label: 'Ações', icon: TrendingUp },
  { path: '/politica', label: 'Política', icon: Landmark },
  { path: '/noticias', label: 'Notícias', icon: Newspaper },
  { path: '/cleptocracia', label: 'Cleptocracia', icon: Gamepad2 },
  { path: '/futdopovo', label: 'Fut do Povo', icon: Trophy },
  { path: '/gas', label: 'Gás do Povo', icon: Flame },
  { path: '/med', label: 'Med do Povo', icon: Stethoscope },
];

export default function Sidebar({ currentPath, onClose }) {
  const location = useLocation();
  const activePath = currentPath || location.pathname;

  return (
    <div className="h-full flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-[var(--border)]">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src={logoGuiaDoPovo}
              alt="Guia do Povo"
              className="h-10 w-auto"
            />
            <span className="text-lg font-bold text-[var(--text)]">Guia do Povo</span>
          </Link>
          {onClose && (
            <button
              onClick={onClose}
              className="ml-auto p-1 rounded-md hover:bg-[var(--accent-soft)] text-[var(--muted)] hover:text-[var(--text)] transition-colors"
            >
              <X size={20} />
            </button>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activePath === item.path || 
            (item.path !== '/' && activePath.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={`
                flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-150
                ${isActive 
                  ? 'bg-[var(--accent-soft)] text-[var(--accent)] font-medium' 
                  : 'text-[var(--muted)] hover:bg-[var(--accent-soft)] hover:text-[var(--text)]'
                }
              `}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* Footer da Sidebar */}
      <div className="p-4 border-t border-[var(--border)]">
        <p className="text-xs text-[var(--muted)] text-center">
          Guia do Povo © 2025
        </p>
      </div>
    </div>
  );
}
